module.exports = __webpack_public_path__ + "img/icon-restaurant-bill.c259431a.png";